import React from "react";
import styles from "./index.module.scss";

interface ProductItem {
  id: string;
  icon: string;
  title: string;
  category: string;
  subcategory: string;
  price: string;
  isComponent?: boolean;
}

const ProductList = () => {
  const products: ProductItem[] = [
    {
      id: "1",
      icon: "/images/attack-surface/generic2.svg",
      title: "Coro Complete License",
      category: "Category",
      subcategory: "Subcategory",
      price: "£ 3.00 /device /mo",
      isComponent: false,
    },
    {
      id: "2",
      icon: "/images/attack-surface/generic2.svg",
      title: "Sentinel One Control License",
      category: "Category",
      subcategory: "Subcategory",
      price: "£ 79.99 per endpoint/year",
      isComponent: false,
    },
    {
      id: "3",
      icon: "/images/attack-surface/generic2.svg",
      title: "Sentinel One Complete License",
      category: "Category",
      subcategory: "Subcategory",
      price: "£ 159.99 per endpoint/year",
      isComponent: false,
    },
    {
      id: "4",
      icon: "/images/attack-surface/generic2.svg",
      title: "Product Generic",
      category: "Category",
      subcategory: "Subcategory",
      price: "£ 209.99 per endpoint/year",
      isComponent: true,
    },
  ];

  return (
    <ul className={styles.list}>
      {products.map((product) => (
        <li key={product.id} className={styles.item}>
          <img
            className={styles.icon}
            alt={`${product.title} icon`}
            src={product.icon}
          />

          <div className={styles.content}>
            <div className={styles.titleContainer}>
              <h3 className={styles.title}>{product.title}</h3>
            </div>

            <p className={styles.description}>
              {product.category} • {product.subcategory} • {product.price}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ProductList;
